import { render, staticRenderFns } from "./DialogConsentTypeDepartment.vue?vue&type=template&id=abbfa996&scoped=true&"
import script from "./DialogConsentTypeDepartment.vue?vue&type=script&lang=js&"
export * from "./DialogConsentTypeDepartment.vue?vue&type=script&lang=js&"
import style0 from "./DialogConsentTypeDepartment.vue?vue&type=style&index=0&id=abbfa996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbfa996",
  null
  
)

export default component.exports